import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SweetPreset } from '@core/config/sweet-preset';
import { authExpiredInterceptor } from '@core/interceptors/auth-expired.interceptor';
import { Chart, registerables } from 'chart.js';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '@features/auth/data-access/auth.service';
import { routes } from './app.routes';
import { environment } from '@environments/environment';

registerLocaleData(localeEn);
Chart.register(...registerables);

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authExpiredInterceptor])),
    providePrimeNG({
      ripple: true,
      license: environment.primeuiLicense,
      theme: {
        preset: SweetPreset,
        options: {
          cssLayer: { name: 'primeng', order: 'theme, base, primeng, components' },
          darkModeSelector: false,
        },
      },
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: `.json?v=${environment.version}`,
      }),
      fallbackLang: environment.defaultLanguage,
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      const authService = inject(AuthService);
      return Promise.all([
        authService.restoreSession(),
        firstValueFrom(translate.use(environment.defaultLanguage)),
      ]).then(() => undefined);
    }),
  ],
};
